import { render, staticRenderFns } from "./createTemplate.vue?vue&type=template&id=71f24c9e&scoped=true"
import script from "./createTemplate.vue?vue&type=script&lang=js"
export * from "./createTemplate.vue?vue&type=script&lang=js"
import style0 from "./createTemplate.vue?vue&type=style&index=0&id=71f24c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f24c9e",
  null
  
)

export default component.exports